import Vue from 'vue'

// axios
import axios from 'axios'
import {
  clearSession,
  getAccessToken,
  getRefreshToken,
  setTokens,
} from '@/services/SessionService';
import { getRestEndpoint } from '../../endpoints';

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: getRestEndpoint(),
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

let refreshPromise = null;

export function refreshAccessToken() {
  const refreshToken = getRefreshToken();

  if (!refreshToken) {
    return Promise.reject(new Error('No refresh token available'));
  }

  if (!refreshPromise) {
    refreshPromise = axiosIns.post('/api/v1/mdm-users/tokens/refresh', { refreshToken }, {
      skipAuthHeader: true,
      skipAuthRefresh: true,
    })
      .then(res => {
        if (!res.data || !res.data.token) {
          throw new Error('No token returned from refresh');
        }
        setTokens(res.data);
        axiosIns.defaults.headers.common.Authorization = `Bearer ${res.data.token}`;
        return res.data.token;
      })
      .catch(error => {
        clearSession();
        delete axiosIns.defaults.headers.common.Authorization;
        throw error;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
}

axiosIns.interceptors.request.use(
  config => {
    const token = getAccessToken();

    if (token && !config.skipAuthHeader) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    } else if (!token && !config.skipAuthHeader && config.headers) {
      // eslint-disable-next-line no-param-reassign
      delete config.headers.Authorization;
    }

    return config;
  },
  error => Promise.reject(error),
)

axiosIns.interceptors.response.use(
  response => response,
  error => {
    const { config, response } = error;

    if (!config || !response || response.status !== 401 || config.retryAuthRefresh || config.skipAuthRefresh) {
      return Promise.reject(error);
    }

    config.retryAuthRefresh = true;

    return refreshAccessToken()
      .then(token => {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
        return axiosIns(config);
      });
  },
)

Vue.prototype.$http = axiosIns

export default axiosIns
